/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    blockquote: "blockquote",
    code: "code",
    h3: "h3",
    a: "a",
    pre: "pre",
    strong: "strong"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "TypeScript(TypeScript)"
    }), "\n", _jsx(_components.p, {
      children: "| v6"
    }), "\n", _jsx(_components.p, {
      children: "styled-components 提供 TypeScript 定义，增强 IDE 中的编辑体验并提高 TypeScript 项目的类型安全性。"
    }), "\n", _jsx(_components.p, {
      children: "¥styled-components provides TypeScript definitions which empowers the editing experience in IDEs and increases type safety for TypeScript projects."
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["对于旧版本的样式组件，可以通过 ", _jsx(_components.code, {
          children: "@types/styled-components"
        }), " NPM 包获取社区定义。"]
      }), "\n", _jsxs(_components.p, {
        children: ["¥For older versions of styled-components, there are community definitions available via the ", _jsx(_components.code, {
          children: "@types/styled-components"
        }), " NPM package."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "创建声明文件(Create a declarations file)"
    }), "\n", _jsx(_components.p, {
      children: "¥Create a declarations file"
    }), "\n", _jsxs(_components.p, {
      children: ["样式组件的 TypeScript 定义可以通过使用自 ", _jsx(_components.code, {
        children: "v4.1.4"
      }), " 版本以来的 ", _jsx(_components.a, {
        href: "https://ts.nodejs.cn/docs/handbook/declaration-merging.html",
        children: "声明合并"
      }), " 进行扩展。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥TypeScript definitions for styled-components can be extended by using ", _jsx(_components.a, {
        href: "https://ts.nodejs.cn/docs/handbook/declaration-merging.html",
        children: "declaration merging"
      }), " since version ", _jsx(_components.code, {
        children: "v4.1.4"
      }), " of the definitions."]
    }), "\n", _jsxs(_components.p, {
      children: ["因此，第一步是创建声明文件。例如，我们将其命名为 ", _jsx(_components.code, {
        children: "styled.d.ts"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥So the first step is creating a declarations file. Let's name it ", _jsx(_components.code, {
        children: "styled.d.ts"
      }), " for example."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "// import original module declarations\nimport 'styled-components';\n\n// and extend them!\ndeclare module 'styled-components' {\n  export interface DefaultTheme {\n    borderRadius: string;\n\n    colors: {\n      main: string;\n      secondary: string;\n    };\n  }\n}\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "React-Native："
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "import 'styled-components/native'\n\ndeclare module 'styled-components/native' {\n  export interface DefaultTheme {\n    borderRadius: string;\n\n    colors: {\n      main: string;\n      secondary: string;\n    };\n  }\n}\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "DefaultTheme"
      }), " 被用作开箱即用的 ", _jsx(_components.code, {
        children: "props.theme"
      }), " 接口。默认情况下，接口 ", _jsx(_components.code, {
        children: "DefaultTheme"
      }), " 是空的，因此我们需要扩展它。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "DefaultTheme"
      }), " is being used as an interface of ", _jsx(_components.code, {
        children: "props.theme"
      }), " out of the box. By default the interface ", _jsx(_components.code, {
        children: "DefaultTheme"
      }), " is empty so that's why we need to extend it."]
    }), "\n", _jsx(_components.h3, {
      children: "创建主题(Create a theme)"
    }), "\n", _jsx(_components.p, {
      children: "¥Create a theme"
    }), "\n", _jsxs(_components.p, {
      children: ["现在我们可以使用上面步骤中声明的 ", _jsx(_components.code, {
        children: "DefaultTheme"
      }), " 创建一个主题。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Now we can create a theme just by using the ", _jsx(_components.code, {
        children: "DefaultTheme"
      }), " declared at the step above."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "// my-theme.ts\nimport { DefaultTheme } from 'styled-components';\n\nconst myTheme: DefaultTheme = {\n  borderRadius: '5px',\n\n  colors: {\n    main: 'cyan',\n    secondary: 'magenta',\n  },\n};\n\nexport { myTheme };\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "样式组件(Styling components)"
    }), "\n", _jsx(_components.p, {
      children: "¥Styling components"
    }), "\n", _jsx(_components.p, {
      children: "就是这样！我们只需使用任何原始导入即可使用样式组件。"
    }), "\n", _jsx(_components.p, {
      children: "¥That's it! We're able to use styled-components just by using any original import."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import styled, { createGlobalStyle, css } from 'styled-components';\n\n// theme is now fully typed\nexport const MyComponent = styled.div`\n  color: ${props => props.theme.colors.main};\n`;\n\n// theme is also fully typed\nexport MyGlobalStyle = createGlobalStyle`\n  body {\n    background-color: ${props => props.theme.colors.secondary};\n  }\n`;\n\n// and this theme is fully typed as well\nexport cssHelper = css`\n  border: 1px solid ${props => props.theme.borderRadius};\n`;\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "使用自定义属性(Using custom props)"
    }), "\n", _jsx(_components.p, {
      children: "¥Using custom props"
    }), "\n", _jsxs(_components.p, {
      children: ["如果你是 ", _jsx(_components.a, {
        href: "https://styled-components.nodejs.cn/docs/basics#adapting-based-on-props",
        children: "根据属性调整样式"
      }), "，并且这些 props 不是基本标签/组件 props 的一部分，你可以使用如下类型参数告诉 TypeScript 这些额外的自定义 props 是什么 (", _jsxs(_components.a, {
        href: "https://github.com/Microsoft/TypeScript/wiki/What%27s-new-in-TypeScript#generic-type-arguments-in-generic-tagged-templates",
        children: ["需要 TypeScript ", _jsx(_components.code, {
          children: "v2.9+"
        })]
      }), ")："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you are ", _jsx(_components.a, {
        href: "https://styled-components.nodejs.cn/docs/basics#adapting-based-on-props",
        children: "adapting the styles based on props"
      }), ", and those props are not part of the base tag / component props, you can tell TypeScript what those extra custom props are, with type arguments like this (", _jsxs(_components.a, {
        href: "https://github.com/Microsoft/TypeScript/wiki/What%27s-new-in-TypeScript#generic-type-arguments-in-generic-tagged-templates",
        children: ["TypeScript ", _jsx(_components.code, {
          children: "v2.9+"
        }), " is required"]
      }), "):"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import styled from 'styled-components';\nimport Header from './Header';\n\ninterface TitleProps {\n  readonly $isActive: boolean;\n}\n\nconst Title = styled.h1<TitleProps>`\n  color: ${(props) => (props.$isActive ? props.theme.colors.main : props.theme.colors.secondary)};\n`;\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["注意：如果你设置标准标签的样式（如上例中的 ", _jsx(_components.code, {
        children: "<h1>"
      }), "），则样式化组件 ", _jsx(_components.a, {
        href: "https://styled-components.nodejs.cn/docs/basics#passed-props",
        children: "不会传递自定义 props"
      }), "（以避免 ", _jsx(_components.a, {
        href: "https://react.nodejs.cn/warnings/unknown-prop.html",
        children: "未知属性警告"
      }), "）。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Note: if you style a standard tag (like ", _jsx(_components.code, {
        children: "<h1>"
      }), " in above example), styled-components ", _jsx(_components.a, {
        href: "https://styled-components.nodejs.cn/docs/basics#passed-props",
        children: "will not pass the custom props"
      }), " (to avoid the ", _jsx(_components.a, {
        href: "https://react.nodejs.cn/warnings/unknown-prop.html",
        children: "Unknown Prop Warning"
      }), ")."]
    }), "\n", _jsx(_components.p, {
      children: "但是，它会将所有这些传递给自定义 React 组件："
    }), "\n", _jsx(_components.p, {
      children: "¥However, it will pass all of them to a custom React component:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import styled from 'styled-components';\nimport Header from './Header';\n\nconst NewHeader = styled(Header)<{ customColor: string }>`\n  color: ${(props) => props.customColor};\n`;\n// Header will also receive props.customColor\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["如果 customColor 属性不应传输到 Header 组件，你可以利用 ", _jsx(_components.a, {
        href: "https://styled-components.nodejs.cn/docs/api#transient-props",
        children: "瞬态属性"
      }), "，在其前面加上美元符号 ($)："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If the ", _jsx(_components.strong, {
        children: "customColor"
      }), " property should not be transferred to the ", _jsx(_components.strong, {
        children: "Header"
      }), " component, you can leverage ", _jsx(_components.a, {
        href: "https://styled-components.nodejs.cn/docs/api#transient-props",
        children: "transient props"
      }), ", by prefixing it with a dollar sign ($):"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import styled from 'styled-components';\nimport Header from './Header';\n\nconst NewHeader2 = styled(Header)<{ $customColor: string }>`\n  color: ${(props) => props.$customColor};\n`;\n// Header does NOT receive props.$customColor\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "根据你的用例，你可以通过自己提取自定义属性来获得类似的结果："
    }), "\n", _jsx(_components.p, {
      children: "¥Depending on your use case, you can achieve a similar result by extracting the custom props yourself:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import styled from 'styled-components';\nimport Header, { Props as HeaderProps } from './Header';\n\nconst NewHeader3 = styled(({ customColor, ...rest }: { customColor: string } & HeaderProps) => <Header {...rest} />)`\n  color: ${(props) => props.customColor};\n`;\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["或者使用 ", _jsx(_components.a, {
        href: "/docs/api#shouldforwardprop",
        children: "shouldForwardProp"
      }), "："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Or using ", _jsx(_components.a, {
        href: "/docs/api#shouldforwardprop",
        children: "shouldForwardProp"
      }), ":"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import styled from 'styled-components';\nimport Header from './Header';\n\nconst NewHeader4 = styled(Header).withConfig({\n  shouldForwardProp: (prop) => !['customColor'].includes(prop),\n})<{ customColor: string }>`\n  color: ${(props) => props.customColor};\n`;\n"
      })
    }), "\n", _jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "className"
      }), " 的警告(Caveat with ", _jsx(_components.code, {
        children: "className"
      }), ")"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Caveat with ", _jsx(_components.code, {
        children: "className"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["定义组件时，你需要在 Props 界面中将 ", _jsx(_components.code, {
        children: "className"
      }), " 标记为可选："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When defining a component you will need to mark ", _jsx(_components.code, {
        children: "className"
      }), " as optional\nin your Props interface:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "interface LogoProps {\n  /* This prop is optional, since TypeScript won't know that it's passed by the wrapper */\n  className?: string;\n}\n\nclass Logo extends React.Component<LogoProps, {}> {\n  render() {\n    return <div className={this.props.className}>Logo</div>;\n  }\n}\n\nconst LogoStyled = styled(Logo)`\n  font-family: 'Helvetica';\n  font-weight: bold;\n  font-size: 1.8rem;\n`;\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "函数组件的注意事项(Caveat with Function Components)"
    }), "\n", _jsx(_components.p, {
      children: "¥Caveat with Function Components"
    }), "\n", _jsx(_components.p, {
      children: "要使用函数组件并对 props 进行类型检查，你需要定义组件及其类型。这对于样式组件来说并不特殊，这就是 React 的工作原理："
    }), "\n", _jsx(_components.p, {
      children: "¥To use function components and have typechecking for the props you'll need to define\nthe component alongside with its type. This is not special to styled-components, this is just\nhow React works:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "interface BoxProps {\n  theme?: ThemeInterface;\n  borders?: boolean;\n  className?: string;\n}\n\nconst Box: React.FunctionComponent<BoxProps> = (props) => <div className={props.className}>{props.children}</div>;\n\nconst StyledBox = styled(Box)`\n  padding: ${(props) => props.theme.lateralPadding};\n`;\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
